"use strict";

import './../../../../js/vue-components/autocomplete-cities';
import './../../../../js/vue-components/autocomplete-labs';

(function(window, $) {

	let url = window.location.href;
	function parseURL(url) {
		var parser = document.createElement('a'),
			searchObject = {},
			queries, split, i;
		// Let the browser do the work
		parser.href = url;
		// Convert query string to object
		queries = parser.search.replace(/^\?/, '').split('&');
		for( i = 0; i < queries.length; i++ ) {
			split = queries[i].split('=');
			searchObject[split[0]] = split[1];
		}
		return {
			protocol: parser.protocol,
			host: parser.host,
			hostname: parser.hostname,
			port: parser.port,
			pathname: parser.pathname,
			search: parser.search,
			searchObject: searchObject,
			hash: parser.hash
		};
	}

	Vue.use(VueGoogleMaps, {
		load: {
			key: 'AIzaSyDWnw7wipXfg0TOMexbK3bL13Coe_GLMEw',
			region: 'CA',
			language: 'en-CA'
		}
	});

	let router = new VueRouter({
		mode: 'history',
		routes: [
			{ path: '/'},
			{ path: '/labs-and-you/labs'},
			{ path: '/hi/shawn'},
		]
	});

	Vue.component('vue-ccil-labs', {

		template: `
			<div class="ccil-labs">
			
				<div class="map-search-filters">
					<div class="container">
					
						<form class="flex-container">
						
							<div class="search-inputs">
							
								<div class="prov-filter col-md-3">
									<label>Filter by Province</label>
									<select class="form-select prov-filter-box" @change="searchFilter" v-model="province">
										<option disabled hidden value="null">All</option>
										<option value='all'>All</option>
										<option value='AB'>Alberta</option>
										<option value="BC">British Columbia</option>
										<option value='MB'>Manitoba</option>
										<option value='NB'>New Brunswick</option>
										<option value='NL'>Newfoundland</option>
										<option value='NS'>Nova Scotia</option>
										<option value='SK'>Saskatchewan</option>
										<option value='ON'>Ontario</option>
										<option value='PE'>Prince Edward Island</option>
										<option value='QC'>Quebec</option>
										<option value='WA'>Washington</option>
										<option value='YT'>Yukon Territory</option>
										all
									</select>
									
								</div>
								
								<div class="program-filter col-md-3">
									<label>Filter by Lab Program</label>
									<select class="form-select program-filter-box" @change="searchFilter" v-model="program">
										<option disabled hidden value="null">All</option>
										<option value="A">All</option>
										<option value="Aggregate">Aggregate</option>
										<option value='Asphalt'>Asphalt</option>
										<option value='Concrete'>Concrete</option>
									</select>
									
								</div>
								
								<div class="membership-filter col-md-3">
									<label>Filter by Membership</label>
									<select class="form-select membership-filter-box" @change="searchFilter" v-model="membership">
										<option disabled hidden value="null">All</option>
										<option value="A">All</option>
										<option value='M'>Corporate Members</option>
										<option value='N'>Non-Corporate Members</option>
									</select>
									
								</div>
								
								<div class="code-filter col-md-3">
									<label>Search a Test Code</label>
									<autocomplete-tests v-model="code" :tests="testsArray" @searchCode="searchFilter" ref="autoCompTest"></autocomplete-tests>
								</div>
							
								<div class="city-filter col-md-3">
									<label>Search a City</label>
									<autocomplete-cities v-model="city" :cities="citiesArray" @searchCity="searchFilter" ref="autoCompCity"></autocomplete-cities>
								</div>
								
								<div class="name-filter col-md-3">
									<label>Search a Lab</label>
									<autocomplete-labs v-model="name" :names="namesArray" @searchName="searchFilter" ref="autoCompLab"></autocomplete-labs>
								</div>
								
							</div>
							
							<button 
								class="btn btn-secondary btn-circle" 
								type="button" 
								ref="search-filter" 
								@searchFilter="searchFilter" 
								@click="searchFilter"
							>
								<span class="sr-only">Search</span>
								<img :src="searchIcon" />
							</button>
						
						</form>
						
					</div>
				</div>
			
			
				<GmapMap
					ref="map"
					name="map"
					:center="center"
					:zoom="zoom"
					map-type-id="terrain"
					style="width: 100%; height: 500px"
				>
				
					<gmap-info-window :options="infoOptions" :position="infoPosition" :opened="infoOpened" @closeclick="infoOpened=false">
						<div id = 'info-window'>
							<h5 class = 'marker-name'>{{infoName}}</h5>
							<hr>
							<p class = 'marker-address'>{{infoAddress}}</p>
						</div>
					</gmap-info-window>
				
					<GmapMarker
						:key="index"
						v-for="(m, index) in cardLabs"
						:position.sync="m.map"
						:clickable="true"
						:draggable="false"
						:icon="m.icon"
						@click="toggleInfo(m, index)"
					/>
					
				</GmapMap>
				
				
				<div class="container">
				
					<div class="top-details">
					
						<div class="paginator-details">
							<span v-if="lastPage == currentPage + 1">Showing {{(10 * currentPage) + 1}} - {{(10 * currentPage) + visibleCards.length}} of {{cardLabs.length}} results</span>
							<span v-else>Showing {{(10 * currentPage) + 1}} - {{visibleCards.length * (currentPage + 1)}} of {{cardLabs.length}} results</span>
						</div>
						
						<div class="member-legend">
							<div>
								<img :src="pinDark" class="pin" /> Non-Corporate Members
							</div>
							<div>
								<img :src="pinRed" class="pin" /> Corporate Members
							</div>
						</div>
						
					</div>
					
					<div class="lab-cards">
						<lab-card 
							v-for="lab in visibleCards" 
							:lab="lab" 
							:key="lab.id" 
							:pin-red="pinRed" 
							:pin-dark="pinDark"
						/>
					</div>
				
					<div style="display: none">
						FirstPage: {{firstPage}} <br>
						LastPage: {{lastPage}} <br>
						CurrentPage: {{currentPage}} <br>
						CurrentPageDummy: {{currentPageDummy}} <br>
						Count: {{visibleCards.length}} <br>
						CountOutOf: {{cardLabs.length}} <br>
						OutOf: {{labs.length}}
					</div>
					
					<div class="last-page-count">
						<span v-if="lastPage == currentPage + 1">Showing {{(10 * currentPage) + 1}} - {{(10 * currentPage) + visibleCards.length}} of {{cardLabs.length}} results</span>
						<span v-else>Showing {{(10 * currentPage) + 1}} - {{visibleCards.length * (currentPage + 1)}} of {{cardLabs.length}} results</span>
					</div>
					
					<div class="pagination-center-wrapper">
						<nav>
							<ul class="pagination">
							
								<li 
									class="page-item page-link page-previous" 
									@click="prevClick"
									:class="(currentPage + 1 == firstPage) ? 'disabled' : ''"
								>
									<span class="sr-only">Previous</span>
								</li>
								
								<li 
									@click="pageNumberClick(firstPage)" 
									class="page-item page-link"
									:class="(currentPage + 1 == firstPage) ? 'active' : ''"
								>
									{{firstPage}}
								</li>
								
								<li 
									v-if="currentPageDummy >= 6 && currentPageDummy < lastPage + 6" 
									@click="pageJumpBack" 
									class="page-item page-link"
								>...</li>
								
								<li 
									v-for="(page, index) in visiblePages" 
									v-if="firstPage != page && lastPage != page" 
									@click="pageNumberClick(page)" 
									class="page-item page-link"
									:class="((currentPage + 1) == page) ? 'active' : ''"
								>
									{{page}}
								</li>
								
								<li 
									v-if="currentPageDummy <= lastPage - 4" 
									@click="pageJumpForward" 
									class="page-item page-link"
								>...</li>
								
								<li 
									@click="pageNumberClick(lastPage)" 
									v-if="lastPage != firstPage" 
									class="page-item page-link"
									:class="(currentPage + 1 == lastPage) ? 'active' : ''"
								>
									{{lastPage}}
								</li>
								
								<li 
									class="page-item page-link page-next" 
									@click="nextClick"
									:class="(currentPage + 1 == lastPage) ? 'disabled' : ''"
								>
									<span class="sr-only">Next</span>
								</li>
							
							</ul>
						</nav>
					</div>
				
				</div>
				
			</div>
		`,

		data () {
			return {
				pinRed: '',
				pinDark: '',
				searchIcon: '',
				citiesArray: [],
				testsArray: [],
				namesArray: [],
				provincesArray: [],
				provCoords: {
					'AB':{lat:55.605328, lng: -115.255760},
					"BC":{lat:55.329158, lng: -125.311272},
					'MB':{lat:55.107110, lng: -97.336523},
					'NB':{lat:46.461672, lng: -64.736573},
					'NL':{lat:51.721480, lng: -55.914697},
					'NS':{lat:45.401723, lng: -63.184727},
					'SK':{lat:54.497455, lng: -105.828935},
					'ON':{lat:48.991912, lng: -82.712002},
					'PE': {lat: 46.510712,lng: -63.416814},
					'QC':{lat:49.764029, lng: -73.948482},
					'WA':{lat:47.595759, lng: -120.025973},
					'YT':{lat:64.011436, lng: -135.644704}
				},
				code:null,
				labsTemp: [],
				labsData: [],
				labs: [],
				center: {lat: 51.508, lng: -91.587},
				zoom: 4,
				markers: [],
				memberMarkers: [],
				province: null,
				program: null,
				membership: 'M',
				divisionsArray: [],
				division: null,
				hideFilter: [],
				city: null,
				name: null,
				places: [],
				cardLabs: [],
				cardLabsMin: [],
				currentPlace: null,
				addressHolder: [],
				firstPage: 1,
				currentPage: 0,
				currentPageDummy: 0,
				pageSize: 10,
				pagesArray: [],
				visibleCards: [],
				visiblePages: [],
				infoPosition: null,
				infoAddress: null,
				infoName: null,
				infoOpened: false,
				infoCurrentKey: null,
				infoOptions: {
					pixelOffset: {
						width: 0,
						height: -35
					}
				},
				paginate: ['cards']
			}
		},

		mounted: function() {

			let prot = 'https://';
			let self = this;
			let base = parseURL(url).hostname;

			if (base == 'cciweb.local') {
				prot = 'http://';
			}
			let assetsURL = prot + base + '/wp-content/themes/ccil-web-2026/assets';
			this.pinRed = assetsURL + '/pin-red.svg';
			this.pinDark = assetsURL + '/pin-dark.svg';
			this.searchIcon = assetsURL + '/search.svg';
			let baseURL = prot + base + '/wp-content/plugins/ccil-labs/src/ccil-labs';
			

			if (base == 'ccil.wp' || base == 'ccil-wp.ddev.site' || base == 'cciweb.local') {
				// baseURL = 'https://ccil-website-sandbox.s3.us-east-2.amazonaws.com';
				baseURL = prot + base + '/wp-content/themes/ccil-web-2026/src/blocks/ccil-labs'
			}
			else{
				baseURL = prot + 'ccil-website.s3.us-east-2.amazonaws.com';
			}


			const ax = axios.create({baseURL: baseURL});

			ax.get('/labs_list.json') // replace on live https://portal.ccil.com/website/ajax_labs
				.then(function (response) {

					self.labs = [];
					self.labsData = response.data;

					for(let labsAddressKey in self.labsData) {

						self.labsTempData = [];

						for (let labsKey in self.labsData[labsAddressKey]) {

							self.labsTempData[labsKey] = self.labsData[labsAddressKey][labsKey];
							self.labsTempData[labsKey].map.lat = parseFloat(self.labsData[labsAddressKey][labsKey].map.lat);
							self.labsTempData[labsKey].map.lng = parseFloat(self.labsData[labsAddressKey][labsKey].map.lng);
							self.citiesArray.push(self.labsData[labsAddressKey][labsKey].addressParse[2]);
							self.labsTempData[labsKey].city = self.labsData[labsAddressKey][labsKey].addressParse[2].toLowerCase();

							self.namesArray.push(self.labsData[labsAddressKey][labsKey].name);
							for (let program_type in self.labsData[labsAddressKey][labsKey].lab_programs) {

								for (let testGroupsindex in self.labsData[labsAddressKey][labsKey].lab_programs[program_type]['tests']) {

									for (let testGroup in self.labsData[labsAddressKey][labsKey].lab_programs[program_type]['tests'][testGroupsindex]) {

										self.testsArray.push(testGroup);

										for (let testCode in self.labsData[labsAddressKey][labsKey].lab_programs[program_type]['tests'][testGroupsindex][testGroup]) {
											self.testsArray.push(self.labsData[labsAddressKey][labsKey].lab_programs[program_type]['tests'][testGroupsindex][testGroup][testCode]);
										}

									}

								}

							}

						}

						self.labs.push(...self.labsTempData);

					}

					const testsArray = self.testsArray;
					self.testsArray = self.uniqueify(testsArray);
					const citiesArray = self.citiesArray;
					self.citiesArray = self.uniqueify(citiesArray);
					self.currentPageDummy = self.currentPage;
					self.namesArray = self.uniqueify(self.namesArray);

					function sortByLabName(a,b) {
						var aName = a.name.toLowerCase();
						var bName = b.name.toLowerCase();
						return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
					}

					self.labs.sort(sortByLabName);

					if (typeof self.$route.query.membership !== 'undefined') {
						self.membership = self.$route.query.membership;
						self.hideFilter.push('membership-filter');
						self.resetMarkers();
						self.setMembership();
					} else {
							self.resetMarkers();
							self.searchFilter();
					}

					for(var i = 1; i< (self.pageCount); i++){
						self.pagesArray.push(i)
					}
					self.updateVisiblePages();

				})

		},

		computed: {
			sortedCities: function(){
				let self = this;

				function compare(a, b) {
					if (a < b)
						return -1;
					if (a > b)
						return 1;
					return 0;
				}
				return this.citiesArray.sort(compare);
			},
			pageCount: function(){
				return (Math.ceil(this.cardLabs.length/this.pageSize));
			},
			lastPage: function() {

				return (Math.ceil(this.cardLabs.length/this.pageSize))
			}
		},

		methods: {
			updateVisibleCards(){
				let self = this;
				if (self.cardLabs.length <= 0) {
					self.visibleCards = [];
					self.currentPageDummy = 0;
				} else {
					self.visibleCards = self.cardLabs.slice((self.currentPage * self.pageSize), (self.currentPage * self.pageSize)+self.pageSize);
					self.currentPageDummy = self.currentPage
				}

				self.updateVisiblePages();
			},
			updateVisiblePages(){
				let self = this;

				if(self.currentPageDummy < 4 ){
					if (self.lastPage > 5) {
						self.visiblePages = self.pagesArray.slice(0, 5)
					} else {
						self.visiblePages = self.pagesArray.slice(0, self.lastPage - 1)
					}
				}
				else if(self.currentPageDummy > (self.lastPage-2)){
					self.visiblePages = self.pagesArray.slice((self.currentPageDummy-7), (self.lastPage - 1))
				}
				else{
					self.visiblePages = self.pagesArray.slice((self.currentPageDummy-4), (self.currentPageDummy +2));
				}

				if (self.visibleCards.length == 0) self.visiblePages = 0;
			},
			updatePage(pageNumber){
				let self = this;
				self.currentPage = pageNumber;
				self.updateVisibleCards();
			},
			setPlace(place) {
				this.currentPlace = place;
			},
			resetMarkers(){
				let self= this;
				self.cardLabs = self.labs;
				for(var key in self.labs){
					const newMarker = {
						lat: parseFloat(self.labs[key].map.lat),
						lng: parseFloat(self.labs[key].map.lng)
					};

					self.markers.push({
						position: newMarker,
						icon: {
							url: this.pinRed
						}
					});

					/*var icon = {
						path: 'M27.648-41.399q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm9.216 0q0 3.924-1.188 6.444l-13.104 27.864q-.576 1.188-1.71 1.872t-2.43.684-2.43-.684-1.674-1.872l-13.14-27.864q-1.188-2.52-1.188-6.444 0-7.632 5.4-13.032t13.032-5.4 13.032 5.4 5.4 13.032z',
						fillColor: '#ec514b',
						fillOpacity: 1,
						strokeWeight: 0,
						scale: 0.5
					};*/

					if (self.labs[key].member) {

						self.cardLabs[key]['icon'] = {
							url: this.pinRed
						};

					} else {

						self.cardLabs[key]['icon'] = {
							url: this.pinDark
						};

					}

				}
				self.updateVisibleCards();
			},
			searchFilter() {

				let self = this;

				self.cardLabsMin = [];
				self.cardLabs = [];
				self.currentPage = 0;

				for(let key in self.labs) {

					// console.log(self.labs[key].name);
					// console.log(self.searchLab(self.labs[key]));
					// console.log(self.searchProvince(self.labs[key]));
					// console.log(self.searchCity(self.labs[key]));
					// console.log(self.searchProgram(self.labs[key]));
					// console.log(self.searchMembership(self.labs[key]));
					// console.log(self.searchCode(self.labs[key]));
					// console.log('===================================================================================');

					if (
						self.searchLab(self.labs[key]) &&
						self.searchProvince(self.labs[key]) &&
						self.searchCity(self.labs[key]) &&
						self.searchProgram(self.labs[key]) &&
						self.searchMembership(self.labs[key]) &&
						self.searchCode(self.labs[key])
					) {
						self.cardLabsMin.push(self.labs[key]);
						self.cardLabs.push(self.labs[key]);
					}

				}

				self.updateVisibleCards();

			},
			searchProvince(lab) {

				let self = this;

				if(lab.addressParse[1] === self.province || self.province === 'all' || !self.province){
					return true;
				}

				return false;

			},
			searchProgram(lab) {

				let
					self = this,
					programCertification = '';

				switch (self.program) {
					case 'Aggregate':
						programCertification = 'Aggregate Certified';
						break;
					case 'Asphalt':
						programCertification = 'Asphalt Certified';
						break;
					case 'Concrete':
						programCertification = 'Concrete Certified';
						break;
					default:
						programCertification = 'A';

				}

				if (programCertification) {
					if (typeof lab.lab_programs[programCertification] !== 'undefined' || programCertification === 'A') {
						return true;
					}
				}

				return false;

			},
			searchMembership(lab) {

				let self = this;

				let member = 0;

				if (self.membership === 'M') {
					member = 1;
				}

				// console.log(self.membership);
				// console.log(member);
				// console.log(lab.member);
				// console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');

				if(lab.member === member || self.membership === 'A' || !self.membership) {
					return true;
				}

				return false;

			},
			searchCode(lab) {

				let self = this;

				if (!self.code) {
					return true;
				}

				for (let program_type in lab.lab_programs) {

					for (let testGroupsindex in lab.lab_programs[program_type]['tests']) {

						for (let testGroup in lab.lab_programs[program_type]['tests'][testGroupsindex]) {

							let re = new RegExp(self.code, 'gi');
							let testCodeSearch = self.code;

							if (self.code) {
								testCodeSearch = self.code.toUpperCase();
							}

							if (
								(
									typeof lab.lab_programs[program_type]['tests'][testGroupsindex][testGroup] !== 'undefined' &&
									(lab.lab_programs[program_type]['tests'][testGroupsindex][testGroup].map(function(x){ return x.toUpperCase() }).indexOf(testCodeSearch) !== -1 ||
										(testGroup.match(re) != null && testGroup.match(re).length > 0))
								) ||
								(
									typeof lab.lab_programs[program_type]['tests'][testGroupsindex][self.code] !== 'undefined'
								) ||
								(
									testCodeSearch == 'LS-609' &&
									lab.lab_programs[program_type]['tests'][testGroupsindex][testGroup].map(function(x){ return x.toUpperCase().substring(0, 6) }).indexOf(testCodeSearch) !== -1
								)
							) {
								return true;
							}
						}
					}
				}

				return false;

			},
			searchCity(lab) {

				let self = this;
				let branch = false;
				let re = new RegExp(self.city, 'gi');

				for (let branchKey in lab.branches) {

					let branchArray = lab.branches[branchKey].split(",");

					if (branchArray[0].match(re)) {
						branch = true;
						break;
					}

				}

				if (
					!self.city ||
					lab.city.match(re) ||
					branch
				) {
					return true;
				}

				return false;

			},
			searchLab(lab) {

				let self = this;

				if (self.name) {

					let pattern = self.name;
					pattern = pattern.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
					let re = new RegExp(pattern, 'gi');

					if(lab.name.match(re)) {
						return true;
					}

				} else {
					return true;
				}

				return false;

			},
			uniqueify(array) {
				var seen = {};
				return array.filter(function(item) {
					return seen.hasOwnProperty(item) ? false : (seen[item] = true);
				});
			},
			pageNumberClick (page) {
				this.currentPage = page -1
				this.currentPageDummy = this.currentPage
				this.updateVisibleCards()
				this.updateVisiblePages()
			},
			prevClick () {
				let self = this
				if(self.currentPage >= 1){
					self.currentPage --
					this.currentPageDummy = this.currentPage
					self.updateVisibleCards()
					self.updateVisiblePages()
				}
			},
			nextClick () {
				let self = this
				if(self.currentPage < (self.pageCount-1)){
					self.currentPage ++
					this.currentPageDummy = this.currentPage
					self.updateVisibleCards()
					self.updateVisiblePages()
				}
			},
			pageJumpBack(){
				this.currentPageDummy = (this.currentPageDummy - 5)
				this.updateVisiblePages()
			},
			pageJumpForward(){
				this.currentPageDummy = (this.currentPageDummy + 5)
				this.updateVisiblePages()
			},
			getPosition: function(marker) {
				return {
					lat: parseFloat(marker.lat),
					lng: parseFloat(marker.lng)
				}
			},
			trigger() {
				let self = this;
				self.$refs.codeSearch.click();
			},
			toggleInfo: function(marker, key) {
				let self = this;
				self.infoPosition = marker.map;
				self.infoName = marker.name;
				self.infoAddress = marker.address;
				setTimeout(()=>{
					if (self.infoCurrentKey == key) {
						self.infoOpened = !self.infoOpened
					} else {
						self.infoOpened = true
						self.infoCurrentKey = key
					}
				},100)
			},
		},

	});

	if ($('#vue-ccil-labs-app').length) {
		new Vue({router, el: '#vue-ccil-labs-app'});
	}

})(window, jQuery);
